// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"20bdfeee","234":"fdcb279f","356":"fce39d4f","414":"48201dc7","430":"6b4e42e4","576":"3f3a3c32","925":"92f8a275"}[chunkId] + ".chunk.js";
};